import axios from 'axios'
export default() => {
    const url = process.env.VUE_APP_API,
        l = window.location,
        baseURL = l.protocol + '//' + url;
    return axios.create({baseURL});
}
